<div *ngIf="!loading">
    <div class="flex-grow-1">
    <div class="row summary-row">
        <div class="col-12">
            <app-summary-totals [summaryData]="summaryData"></app-summary-totals>
        </div>
    </div>
    <div class="row flex-grow-1">
        <div id="filters" class="row pt-2">
            <div class="col-12">
                <mat-form-field appearance="fill" [hidden]="!regionList || regionList.length == 0 || locationId" style="width: 14%">
                    <mat-label>Region</mat-label>
                    <mat-select [(value)]="selectedRegionId" (selectionChange)="regionChange($event.value)">
                        <mat-option>None</mat-option>
                        <mat-option *ngFor="let region of regionList" [value]="region.id">{{region.name}}</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="fill" [hidden]="locationId" style="width: 16%">
                    <mat-label>Depot</mat-label>
                    <mat-select [(value)]="selectedDepotId" (selectionChange)="depotChange($event.value)">
                        <mat-option>None</mat-option>
                        <mat-option *ngFor="let depot of depotList" [value]="depot.id">{{depot.name}}</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="fill" [hidden]="locationId" style="width: 26%">
                    <mat-label>Location</mat-label>
                    <mat-select [(value)]="selectedLocationId" (selectionChange)="locationChange($event.value)">
                        <mat-option>None</mat-option>
                        <mat-option *ngFor="let location of locationList" [value]="location.id">{{location.name}}</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="fill" hidden style="width: 16%">
                    <mat-label>Show</mat-label>
                    <mat-select [(value)]="selectedShowSetting" (selectionChange)="showSettingChange($event.value)">
                        <mat-option>All</mat-option>
                        <mat-option value={{ShowSetting[ShowSetting.Surplus]}}>Surplus</mat-option>
                        <mat-option value={{ShowSetting[ShowSetting.Deficit]}}>Deficit</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="fill" hidden style="width: 20%">
                    <mat-label>Status</mat-label>
                    <mat-select [(value)]="selectedDamageStatus" (selectionChange)="damageStatusChange($event.value)">
                        <mat-option>None</mat-option>
                        <mat-option value={{DamageStatus[DamageStatus.InService]}}>In Service</mat-option>
                        <mat-option value={{DamageStatus[DamageStatus.Damaged]}}>Damaged</mat-option>
                        <mat-option value={{DamageStatus[DamageStatus.DamagedInService]}}>Damaged In Service</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div id="containers" class="col-md-5 col-12 pr-1 flex-grow-1 d-flex flex-column" appSetHeight>
            <app-widget-containers [containers]="containers" [location]="location" [hidden]="!location || !selectedLocationId"></app-widget-containers>
        </div>
        <div class="col-md-7 col-12 pl-1 flex-grow-1 d-flex flex-column" appSetHeight [padding]="20" [overflow]="'auto'">
        <div class="col-12 pl-0 pr-0 flex-grow-1">
            <div class="h-100 overflow-auto">
                <div class="col-12 summary pl-0">
                    <div id="report">
                        <div id="jobs" *ngIf="jobs">
                            <h5>Jobs</h5>
                            <table class='table table-striped' aria-labelledby="tableLabel">
                                <thead>
                                <tr>
                                    <th class="description2">
                                        VEHICLE
                                    </th>
                                    <th class="location">
                                        LOCATION NAME
                                    </th>
                                    <th class="type">
                                        CONTAINER IN
                                    </th>
                                    <th class="type">
                                        CONTAINER OUT
                                    </th>
                                    <th class="type">
                                        FINISHED TIME
                                    </th>
                                    <th class="type">
                                        JOB TYPE
                                    </th>
                                </tr>
                                </thead>
                                <tbody class="dummy">
                                <tr>
                                    <td class="h-2" colspan="12"></td>
                                </tr>
                                </tbody>
                                <tbody>
                                    <ng-container *ngFor="let job of jobs">
                                        <tr>
                                            <td class="description2">
                                                <div class="innerWrapper">
                                                    <span class="default" title="{{ job.blackBoxName }}">{{ job.blackBoxName }}</span>
                                                </div> 
                                            </td>
                                            <td class="location">
                                                <div class="innerWrapper">
                                                    <span class="default" title="{{ job.locationName }}">{{ job.locationName }}</span>
                                                </div> 
                                            </td>
                                            <td class="type">
                                                <div class="innerWrapper">
                                                    <span class="default" title="{{ job.containerIn }}">{{ job.containerIn }}</span>
                                                </div> 
                                            </td>
                                            <td class="type">
                                                <div class="innerWrapper">
                                                    <span class="default" title="{{ job.containerOut }}">{{ job.containerOut }}</span>
                                                </div> 
                                            </td>
                                            <td class="type">
                                                <div class="innerWrapper">
                                                    <span class="default">{{ job.finishedDisplay }}</span>
                                                </div> 
                                            </td>
                                            <td class="type">
                                                <div class="innerWrapper">
                                                    <span class="default">{{ job.jobTypeName }}</span>
                                                </div> 
                                            </td>
                                        </tr>
                                    </ng-container>
                                </tbody>
                            </table>
                            <app-paging [paging]="jobsPaging" [pageChangeFunction]="jobsChangePage" [parentComponent]="this" showPageLabel="true"></app-paging>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>